import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface TaskStatusChangedEventProps {
  event: DiscriminatedTaskStatusChangedEvent;
}

export const TaskStatusChangedEvent: React.FC<TaskStatusChangedEventProps> = ({
  event,
}) => {
  const { task, old: oldStatus, new: newStatus } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <ArrowPathIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {task?.name && <ActivityTitle>{task.name}</ActivityTitle>}
        {oldStatus?.canonical_status && newStatus?.canonical_status && (
          <ActivityStatusTransition
            from={formatStatus(oldStatus.canonical_status)}
            to={formatStatus(newStatus.canonical_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  const actions = task?.id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/updates?task_id=${task.id}`}
      >
        View Task
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
